import React from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../store/store";
import { login, logout, checkAuthentication } from "../redux/authSlice";
import { useEffect, useState } from "react";

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const authState = useSelector((state: RootState) => state.auth);
  const { isAuthenticated, userName } = useSelector(
    (state: RootState) => state.auth,
  );
  console.log("Redux state in Header.tsx:", authState);

  //Ensure authentication check runs once when the app loads
  useEffect(() => {
    dispatch(checkAuthentication());
  }, [dispatch]);

  // Trigger a re-render ONLY when `isAuthenticated` changes
  const [renderCount, setRenderCount] = useState(0);
  useEffect(() => {
    setRenderCount((prev) => prev + 1);
  }, [isAuthenticated]);

  console.log("Redux State in Header:", { isAuthenticated, userName });

  return (
    <header
      style={{
        backgroundColor: "#f0f0f0",
        color: "#333",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "15px 20px",
        height: "52px",
        fontFamily: "'TheSans', sans-serif",
        fontSize: "11.9px",
      }}
    >
      {/* =Left: Logo  */}
      <img src="/ap_logo.png" alt="Company Logo" style={{ height: "45px" }} />

      {/* Project Name */}
      <h1
        style={{
          margin: 0,
          fontSize: "18px",
          fontWeight: "bold",
          flex: 1,
          textAlign: "center",
          color: "rgb(0, 154, 73)",
        }}
      >
        LHYST Surcharge Tool
      </h1>

      {/* Right: User Info / Login & Logout */}
      <div
        style={{
          minWidth: "180px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {isAuthenticated ? (
          <>
            <span style={{ marginTop: "2%" }}>👤 {userName} </span>
            {/* below option is better as it properly logs out:  <button onClick={() => { msalInstance.logoutPopup(); dispatch(logout());window.location.reload(); }}>Logout</button> */}
            <button
              onClick={async () => {
                await dispatch(logout()).unwrap();
                window.location.reload(); // Force page refresh after logout
              }}
              style={{ marginLeft: "10px" }}
            >
              Logout
            </button>
          </>
        ) : (
          <button
            onClick={async () => {
              try {
                const result = await dispatch(login()).unwrap(); // Fixes "object is of type unknown"
                console.log("Login successful:", result);
              } catch (err) {
                console.error(" Login failed:", err);
              }
            }}
          >
            Login
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
